import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=06cdb7c1&scoped=true&"
import script from "./Tiers.vue?vue&type=script&lang=js&"
export * from "./Tiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdb7c1",
  null
  
)

export default component.exports